import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { HeurePointeeChantierDto } from './dto/heure-pointee-chantier.dto'
import { PatchHeurePointeeDto } from './dto/patch-heure-pointee.dto'

@Injectable({providedIn: 'root'})
export class HeurePointeeHttp {
  private static readonly endpoint = environment.baseUrl + '/heures-pointees'
  private readonly http = inject(HttpClient)

  getHeurePointeeByChantierCodeAndPeriode(codeChantier: string, periode: string): Observable<HeurePointeeChantierDto> {
    return this.http.get<HeurePointeeChantierDto>(`${HeurePointeeHttp.endpoint}/${codeChantier}/${periode}`)
  }

  patchHeurePointee(
    insertionChantierId: number,
    periode: string,
    body: PatchHeurePointeeDto
  ): Observable<HeurePointeeChantierDto> {
    return this.http.patch<HeurePointeeChantierDto>(
      `${HeurePointeeHttp.endpoint}/${insertionChantierId}/${periode}`,
      body
    )
  }

  exportAsGoogleSheet(codeChantier: string): Observable<void> {
    return this.http.get<void>(HeurePointeeHttp.endpoint + `/${codeChantier}/export`)
  }
}
